<template>
  <div :class="`calendar-entry is-important ${entryColor}`">
    <header class="entry-date">
      {{ headerText }}
    </header>
    <b-icon
      class="sticky-note"
      v-if="entry.notificationCount > 0"
      icon="sticky-note"
    ></b-icon>

    <header></header>
    <header class="entry-icon" v-if="!!entry.important">
      <b-icon icon="exclamation-circle" class="is-important"></b-icon>
    </header>
    <div class="entry-label is-size-6">
      {{ entryLabel }}
    </div>
    <div class="entry-comment is-size-6">
      {{ entry.comment }}
    </div>
    <div class="entry-note is-size-6">
      {{ circleLabel }}
      <span v-if="entry.nextDayEmployeeName">
        - Omstilling til '{{ entry.nextDayEmployeeName }}'</span
      >
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "calendar-entry",
  props: {
    entry: Object,
    allocationTypes: {
      type: Object,
      default: () => ({}),
    },
    circlesLookup: {
      type: Array,
      default: () => [],
    },
  },
  methods: {},
  computed: {
    ...mapGetters(["currentUser"]),
    isCurrentUser() {
      if (!this.entry) {
        return false;
      }

      return this.currentUser.id === this.entry.employeeId;
    },
    entryStart() {
      return this.entry.startDate !== undefined
        ? moment(this.entry.startDate)
        : undefined;
    },
    entryEnd() {
      return this.entry.endDateInclusive !== undefined
        ? moment(this.entry.endDateInclusive)
        : undefined;
    },
    entryDuration() {
      if (this.entryStart !== undefined && this.entryEnd !== undefined) {
        return this.entryEnd.diff(this.entryStart, "milliseconds");
      }
      return 0;
    },
    entryCircle() {
      return this.circlesLookup.find((q) => q.id === this.entry.circleId);
    },
    entryColor() {
      if (
        this.entry.allocationType === "OFFDAYREPLACEMENT" ||
        !this.entry.employeeId
      ) {
        return "ivory";
      }

      if (this.entry.allocationType === "OFFDAY") {
        return "yellow";
      }

      if (this.entry.allocationType !== undefined && !this.entry.circleId) {
        return "timeoff";
      }
      if (this.entry.replacementId) {
        return "green";
      }

      return this.entryCircle === undefined
        ? "blue"
        : this.entryCircle.colorCode;
    },
    entryLabel() {
      let label = "";
      if (this.entry.allocationType !== undefined) {
        if (
          this.isReplacement &&
          this.entry.allocationType === "OFFDAYREPLACEMENT"
        ) {
          return "Ledig";
        }
        if (this.entry.replacementId) {
          if (this.isCurrentUser) {
            label =
              "Afløst af: " +
              this.entry.replacementNumber +
              " - " +
              this.entry.replacementName;
          } else {
            label =
              "Afløser: " + this.entry.number + " - " + this.entry.employeeName;
          }
        } else {
          label = this.allocationTypes[this.entry.allocationType];
        }
      } else if (this.entryCircle !== undefined) {
        label = this.entryCircle.title;
      }
      return `${label}`;
    },
    circleLabel() {
      return this.entryCircle === undefined ? "" : this.entryCircle.title;
    },
    headerText() {
      if (!this.entry) {
        return "";
      }

      let date = moment(this.entry.calendarDate);

      if (!date) {
        date = this.entryStart;
      }

      const dateText = `${date?.format("dddd")} d. ${date?.format(
        "DD"
      )}. ${date?.format("MM")}`;

      return `${_.upperFirst(dateText)}`;
    },
  },
};
</script>

<style lang="scss">
.calendar-entry {
  display: grid;
  grid-template-columns: auto 24px;
  grid-template-rows: 24px 24px auto;
  grid-template-areas:
    "date icon"
    "label icon"
    "comment icon"
    "note icon";
  margin-bottom: 10px;
  // border-radius: 6px;
  text-align: left;

  .entry-date {
    grid-area: date;
    font-size: 1.25rem;
  }
  .entry-icon {
    grid-area: icon;
    font-size: x-large;

    svg {
      background-color: white;
      color: $important;
      border-radius: 50%;
      border-width: 2px;
      padding: 2px;
    }
  }
  .entry-label {
    grid-area: label;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .entry-note {
    grid-area: note;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .entry-comment {
    grid-area: comment;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.sticky-note {
  opacity: 85%;
}

@media only screen and (max-width: 450px) {
  .calendar-entry {
    padding: 5px 10px;
  }
  .entry-date {
    font-size: 4vw !important;
  }
  .entry-label {
    font-size: 4vw !important;
  }
  .entry-note {
    font-size: 4vw !important;
  }
  .entry-comment {
    font-size: 4vw !important;
  }
}
</style>
